import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AppModule } from '@modules/core/plugins/AppModule';
import { FinanceMonthReportModule } from '@modules/finance/submodules/month-report/FinanceMonthReportModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERSHIP_MENU_ITEM,
  AFFILIATE_REPORTS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_FINANCE_LIST_ROUTE_NAME,
  ADMIN_FINANCE_ROUTE_NAME,
  AFFILIATE_FINANCE_LIST_ROUTE_NAME,
  AFFILIATE_FINANCE_ROUTE_NAME,
  FINANCE_PERMISSIONS,
  TRANSLATION_GROUP_FINANCE,
} from './constants';
import { getTranslationKeys } from './translations';

export class FinanceModule extends AppModule {
  protected submodules = [new FinanceMonthReportModule()];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_FINANCE_ROUTE_NAME,
      path: 'finance',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'FinanceListPage',
    });

    router.addChildRoute(ADMIN_FINANCE_ROUTE_NAME, {
      name: ADMIN_FINANCE_LIST_ROUTE_NAME,
      path: '',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('./pages/FinanceListPage/FinanceListPage.vue'),
    });

    router.addAffiliateRoute({
      name: AFFILIATE_FINANCE_ROUTE_NAME,
      path: 'finance',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'FinanceListPage',
    });

    router.addChildRoute(AFFILIATE_FINANCE_ROUTE_NAME, {
      name: AFFILIATE_FINANCE_LIST_ROUTE_NAME,
      path: '',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('./pages/FinanceListPage/FinanceListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERSHIP_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_BOOKKEEPING'),
      to: {
        name: ADMIN_FINANCE_LIST_ROUTE_NAME,
      },
      permission: FINANCE_PERMISSIONS.SHOW,
      id: ADMIN_FINANCE_LIST_ROUTE_NAME,
      order: 50,
    });

    menu.addChildAffiliateMenuItem(AFFILIATE_REPORTS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'REPORTS_BOOKKEEPING'),
      to: {
        name: AFFILIATE_FINANCE_LIST_ROUTE_NAME,
      },
      permission: FINANCE_PERMISSIONS.SHOW,
      id: AFFILIATE_FINANCE_LIST_ROUTE_NAME,
      order: 40,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_FINANCE, getTranslationKeys);
  }
}
